import { CommonModule } from "@angular/common";
import { Component, NgModule, Output, EventEmitter, ElementRef, AfterViewInit, OnDestroy, Input } from "@angular/core";
import * as events from "devextreme/events";
import { AppStateManageService } from "../../../services/app-state-manage.service";
import { NavigationEnd, Router } from "@angular/router";
import { SidebarMenuStateService } from "../../../services/sidebarmenustateservice";
import { Subscription } from "rxjs";
import { SUBMENU_ID } from "../../../classes/domain/constants";
import { TranslationHelperService } from "../../../services/translationhelper.service";
import { TranslateService } from "@ngx-translate/core";

export interface NavItem_Entity_Authority {
  Feature: string;
  FeatureGroup: string;
  MenuId: string;
  CanAdd?: boolean;
  CanView: boolean;
  CanEdit?: boolean;
  CanDelete?: boolean;
  CanExport?: boolean;
}

@Component({
  selector: "app-side-navigation-menu",
  templateUrl: "./side-navigation-menu.component.html",
  styleUrls: ["./side-navigation-menu.component.scss"],
  standalone: false,
})
export class SideNavigationMenuComponent implements AfterViewInit, OnDestroy {

  @Output() openMenu = new EventEmitter<any>();
  @Output() selectedItemChanged = new EventEmitter<any>();

  SideBarMenuItemList: NavItem_Entity_Authority[] = [];
  public items: any[] = [];
  activeFeature: string = '';
  private menuSubscription!: Subscription;
  private langSubscription!: Subscription;

  private featureIconMap: Record<string, { icon: string; selectedIcon: string }> = {
    Dashboard: { icon: '/assets/icons/dashboard.png', selectedIcon: '/assets/icons/filled_dashboard_pink.png' },
    Master: { icon: '/assets/icons/Master-Feature.png', selectedIcon: '/assets/icons/filled_masters_pink.png' },
    Transaction: { icon: '/assets/icons/Transaction-Feature.png', selectedIcon: '/assets/icons/filled_transaction_pink.png' },
    Reports: { icon: '/assets/icons/Reports-Feature.png', selectedIcon: '/assets/icons/filled_report_pink.png' },
  };

  private defaultIcon = {
    icon: '/assets/icons/masters.png',
    selectedIcon: '/assets/icons/masters_active.png'
  };

  constructor(
    private elementRef: ElementRef,
    private sidebarMenuState: SidebarMenuStateService,
    private router: Router,
    private appStateManage: AppStateManageService,
    private translationHelper: TranslationHelperService,
    private translate: TranslateService
  ) { }

  onItemClick2(item: any) {
    const featureName = item?.featureName || '';
    this.activeFeature = featureName;

    this.selectedItemChanged.emit({ itemData: item });

    if (featureName === 'Dashboard') {
      this.router.navigate(['home']);
      return;
    }
    this.router.navigate([SUBMENU_ID.FEATURE_GROUP, featureName]);
  }

  @Input() set selectedItem(value: string) {
    // kept for parent compatibility
  }

  @Input() set compactMode(value: boolean) {
    // kept for parent compatibility
    // no dx-tree-view anymore so nothing to collapse
  }

  ngAfterViewInit() {
    events.on(this.elementRef.nativeElement, "dxclick", (e: Event) =>
      this.openMenu.next(e)
    );
  }

  async ngOnInit() {
    const LoginToken = this.appStateManage.StorageKey.getItem('LoginToken');
    if (!LoginToken) return;

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects;
        const match = url.match(/Feature-Group\/([^?#]+)/);
        if (match) {
          this.activeFeature = decodeURIComponent(match[1] || '');
        } else if (url.includes('home')) {
          this.activeFeature = 'Dashboard';
        }
      }
    });

    // ✅ Replaces raw onLangChange — fires only after file is loaded
    this.langSubscription = this.translationHelper.whenLangReady()
      .subscribe(() => {
        this.GenerateAndSetMenuItemModuleList();
      });

    const url = this.router.url;
    const match = url.match(/Feature-Group\/([^?#]+)/);
    if (match) {
      this.activeFeature = decodeURIComponent(match[1] || '');
    } else if (url.includes('home')) {
      this.activeFeature = 'Dashboard';
    }

    this.menuSubscription = this.sidebarMenuState.menu$
      .subscribe(async (menu: NavItem_Entity_Authority[]) => {
        this.SideBarMenuItemList = menu;
        await this.GenerateAndSetMenuItemModuleList();
      });
  }

  private GenerateAndSetMenuItemModuleList = async () => {
    const features = [...new Set(this.SideBarMenuItemList.map(m => m.Feature))];
    this.items = features.map(feature => {
      const icons = this.featureIconMap[feature] || this.defaultIcon;
      return {
        text: this.translationHelper.getFeature(feature),
        featureName: feature,
        icon: icons.icon,
        selectedIcon: icons.selectedIcon,
      };
    });
  };

  ngOnDestroy() {
    events.off(this.elementRef.nativeElement, "dxclick");
    if (this.menuSubscription) {
      this.menuSubscription.unsubscribe();
      this.langSubscription?.unsubscribe();
    }
  }
}

@NgModule({
  imports: [CommonModule],   // 👈 THIS is what makes *ngFor work
  declarations: [SideNavigationMenuComponent],
  exports: [SideNavigationMenuComponent],
})
export class SideNavigationMenuModule { }